import { render } from "./FeedCard.vue?vue&type=template&id=a362953e&scoped=true"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"

import "./recipeCard.css?vue&type=style&index=0&id=a362953e&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a362953e"]])

export default __exports__